import { render } from "./submissions-notification-message.vue?vue&type=template&id=8b4d4d98&scoped=true&ts=true"
import script from "./submissions-notification-message.vue?vue&type=script&lang=ts"
export * from "./submissions-notification-message.vue?vue&type=script&lang=ts"

import "./submissions-notification-message.vue?vue&type=style&index=0&id=8b4d4d98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4d4d98"]])

export default __exports__